import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';

@Component({
  selector: 'app-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.scss'],
})
export class DropdownSearchComponent implements OnInit {

  @Output()
  onTextInput: EventEmitter<string> = new EventEmitter<string>();

  control = new UntypedFormControl();
  inputFocused = false;

  @Input() searching = false;
  @Input() dropdownSearchDebounceTime = 1000;

  @Input() placeholder;

  ngOnInit(): void {
    this.initInputValueSubscription();
  }

  initInputValueSubscription(): void {
    this.control.valueChanges
      .pipe(
        tap(() => {
          if (this.dropdownSearchDebounceTime) {
            this.searching = true;
          }
        }),
        debounceTime(this.dropdownSearchDebounceTime),
        distinctUntilChanged(),
      )
      .subscribe(query => {
        if (this.dropdownSearchDebounceTime) {
          this.searching = !!query;
        }

        this.onTextInput.emit(query);
      });
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.control.reset();
    this.onTextInput.emit(null);
  }

  onFocus(event) {
    this.inputFocused = true;
  }
}
